import React from 'react';
import { Typography } from 'antd';
import SbModal from 'uiCore/SbModal/SbModal';
import SbButton from 'uiCore/SbButton/SbButton';
import { PUBLISH_BOX, PUBLISH_BOX_ACTION, getPublishBoxButtons } from 'Utils/sendAndPublish';

const { Text } = Typography;

// "Publish without a review?" (wireframe): opened by every HR Manager Publish, every time, with no "Don't ask
// again". Cancel (closes the box, nothing happens), Send for Approval (to the approver page), Save as Draft (only
// from the editor), Yes, publish now. Close and Esc do nothing: the user picks a button.
//   open, fromEditor, busy — shown, opened from the editor, an action is in flight
//   saveDraftDisabled      — the editor's content can't be saved as a draft ("Make changes first")
//   onAction(action)       — PUBLISH_BOX_ACTION.CANCEL | SEND | SAVE_DRAFT | PUBLISH
const PublishWithoutReviewModal = ({ open, fromEditor, busy, saveDraftDisabled, onAction }) => (
  <SbModal
    open={open}
    title={PUBLISH_BOX.title}
    closable={false}
    maskClosable={false}
    keyboard={false}
    wrapClassName="jd-confirm-modal"
    footer={getPublishBoxButtons({ fromEditor }).map((button) => (
      <SbButton
        key={button.action}
        buttonType={button.primary ? 'primary' : 'secondary'}
        loading={busy && button.primary}
        disabled={busy || (button.action === PUBLISH_BOX_ACTION.SAVE_DRAFT && !!saveDraftDisabled)}
        onClick={() => onAction(button.action)}
      >
        {button.label}
      </SbButton>
    ))}
  >
    <p>{PUBLISH_BOX.body}</p>
    <Text type="secondary">{PUBLISH_BOX.secondary}</Text>
  </SbModal>
);

export default PublishWithoutReviewModal;
